import React, { useState } from "react";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Is there a free trial available?",
      answer:
        "Yes, you can try us for free for 30 days. If you want, we'll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",
    },
    {
      question: "Can I change my plan later?",
      answer:
        "Yes, you can change your plan at any time. Your billing will be prorated based on the new plan.",
    },
    {
      question: "What is your cancellation policy?",
      answer:
        "You can cancel your subscription at any time. There are no long-term contracts or cancellation fees.",
    },
    {
      question: "Can other info be added to an invoice?",
      answer:
        "Yes, you can add custom information to your invoices including PO numbers, company details, and additional notes.",
    },
    {
      question: "How does billing work?",
      answer:
        "We bill monthly or yearly depending on your preference. All plans are billed in advance.",
    },
    {
      question: "How do I change my account email?",
      answer:
        "You can change your account email from your account settings page. We'll send a verification email to confirm the change.",
    },
  ];

  return (
    <div className=" relative max-w-[1200px] border-r border-l mx-auto px-4 py-16">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center w-28 justify-center p-1 bg-gradient-to-b from-gray-100 to-white mx-auto mb-8 rounded-full">
            <div className="px-6 py-2 text-gray-600 font-medium bg-white border border-2 rounded-full geist-mono">
              FAQ's
            </div>
          </div>
          <h2 className="text-4xl font-bold text-[#212F40]">
            Frequently asked questions
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200 pb-4">
              <button
                className="w-full flex items-center justify-between text-left py-4 "
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              >
                <span className="text-lg text-[#212F40] font-medium  hover:text-blue-600 transition-transform duration-300 ">
                  {faq.question}
                </span>
                <span className="ml-6 flex-shrink-0">
                  {openIndex === index ? (
                    <svg
                      className="h-6 w-6 text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20 12H4"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="h-6 w-6 text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6v12M6 12h12"
                      />
                    </svg>
                  )}
                </span>
              </button>

              {openIndex === index && (
                <div className="pb-4 pr-12">
                  <p className="text-[#697586]">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="absolute -bottom-px -right-px w-4 h-4 border-t-2 border-r-2 border-black rotate-90"></div>

      <div className="absolute left-1 -translate-x-1 -bottom-2 w-4 h-4 rounded-full border border-[#cfd5de] bg-white"></div>
    </div>
  );
};

export default FAQSection;
